// import { ActionPerformed } from '@capacitor/push-notifications';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { INotificationData } from 'bg-server/src/components/api/v1/push/notification/types';

import { pushNotificationService } from '../../services/pushNotification';
import { setLoadingStatus } from '../app';
import { ICoreState } from '../types';

export const loadUserNotifications = createAsyncThunk<INotificationData[], void, { state: ICoreState }>('push/loadUserNotifications', async (_data, thunkAPI) => {
    const { getState, requestId, dispatch } = thunkAPI;
    try {
        const { currentRequestId } = getState().push;
        if (currentRequestId && requestId !== currentRequestId) {
            return null;
        }

        dispatch(setLoadingStatus(true));
        const notifications = await pushNotificationService.loadUserNotificationsSvc();
        dispatch(setLoadingStatus(false));
        return notifications;
    } catch (error) {
        dispatch(setLoadingStatus(error.message));
        throw error;
    }
});
